/** Global constants. */
export const CONST = {
	/** Domain the the application is hosted on in production. */
	APP_DOMAIN: 'nrfcloud.nordicsemi.com',
	/** Target for "Get Started" links. */
	NRFCLOUD_START_URL: 'https://start.nrfcloud.com',
	/** Memfault registration url */
	REGISTER_URL: 'https://app.memfault.com/register',
	/** Memfault login url */
	LOGIN_URL: 'https://app.memfault.com/login',
	/** utm_source for links to other nordic sites. */
	UTM_SOURCE: 'nrf-cloud-web',
	/**
	 * Url to the new nRF Cloud docs site.
	 *
	 * Note: There was previously a 301 redirect from docs.nrfcloud.com to
	 * docs.nordicsemi.com. When linking to the root docs page, append `/?new` to
	 * this url to bust the cache in browsers that requested this page while
	 * the redirect was in place.
	 */
	NRFCLOUD_DOCS_URL: 'https://docs.nrfcloud.com',
	UTM_CAMPAIGNS: {
		HOME: 'home',
		DEVICE_MANAGEMENT: 'DM-page',
		DEVICE_OBSERVABILITY: 'olly-page',
		LIFETIME_FOTA: 'lifetime-fota',
		LOCATION_SERVICES: 'location-services',
		PRICING: 'pricing',
		PRICING_CALCULATOR: 'calculator',
		SECURITY_SERVICES: 'SS-page',
	},
} as const
